import {
  FileText,
  Users,
  Building2,
  Settings,
  LayoutDashboard,
  Palette,
  Truck,
  type LucideIcon,
} from "lucide-react";
import { Permission } from "@/constants/permissions.constants";

export interface NavigationItem {
  titleKey: string;
  url: string;
  icon: LucideIcon;
  matchUrls?: string[];
  requiredPermission?: Permission;
  hideOnMobile?: boolean;
}

import { PERMISSIONS } from "@/constants/permissions.constants";

export const NAVIGATION_ITEMS: NavigationItem[] = [
  {
    titleKey: "navigation.dashboard",
    url: "/dashboard",
    icon: LayoutDashboard,
    matchUrls: ["/dashboard"],
  },
  {
    titleKey: "navigation.invoices",
    url: "/dashboard/invoices",
    icon: FileText,
    matchUrls: ["/dashboard/invoices"],
    requiredPermission: PERMISSIONS.INVOICES_VIEW,
  },
  {
    titleKey: "navigation.customers",
    url: "/dashboard/customers",
    icon: Users,
    matchUrls: ["/dashboard/customers"],
    requiredPermission: PERMISSIONS.CUSTOMERS_VIEW,
  },
  {
    titleKey: "navigation.templateCustomizer",
    url: "/dashboard/template-customizer",
    icon: Palette,
    matchUrls: ["/dashboard/template-customizer"],
    requiredPermission: PERMISSIONS.INVOICE_DESIGN_VIEW,
    hideOnMobile: true,
  },
  {
    titleKey: "navigation.shippingRates",
    url: "/dashboard/shipping-rates",
    icon: Truck,
    matchUrls: ["/dashboard/shipping-rates"],
    requiredPermission: PERMISSIONS.SHIPPING_VIEW,
  },
  {
    titleKey: "navigation.company",
    url: "/dashboard/company-details",
    icon: Building2,
    matchUrls: ["/dashboard/company-details"],
    requiredPermission: PERMISSIONS.COMPANY_VIEW,
  },
  {
    titleKey: "navigation.settings",
    url: "/dashboard/settings",
    icon: Settings,
    matchUrls: ["/dashboard/settings"],
    requiredPermission: PERMISSIONS.SETTINGS_VIEW,
  },
];
